import { observer } from 'mobx-react-lite';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { BasePage, PageType } from 'src/components/BasePage';
import { EntityProfileDetails } from 'src/pages/AgentProfilePage/EntityProfileDetails';
import { EntityProfileEdit } from 'src/pages/AgentProfilePage/EntityProfileEdit';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';

export type EntityPresentationProfileProps = {
    store: BasicStore<any>;
    entityName: string;
};
export const EntityPresentationProfile = observer(
    ({ store, entityName }: EntityPresentationProfileProps) => {
        const { path, url } = useRouteMatch();

        return (
            <BasePage pageName={entityName} type={PageType.FULL}>
                <Switch>
                    {store.itemDetailsFormKey && (
                        <Route
                            path={`${path}/:entityId`}
                            exact
                            render={() => (
                                <EntityProfileDetails store={store} />
                            )}
                        />
                    )}
                    {store.itemEditFormKey && (
                        <Route
                            path={`${path}/:entityId/edit`}
                            exact
                            render={() => (
                                <EntityProfileEdit
                                    store={store}
                                    entityListUrl={url}
                                />
                            )}
                        />
                    )}
                    <Route
                        path={`${path}/*`}
                        exact
                        render={() => <Redirect to={path} />}
                    />
                </Switch>
            </BasePage>
        );
    },
);
